var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackToCabinet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1543 15.4898C16.4883 15.7676 16.9559 15.8309 17.3531 15.6445C17.7504 15.4582 18 15.0609 18 14.625V3.375C18 2.93907 17.7469 2.5418 17.3531 2.35547C16.9594 2.16915 16.4918 2.22891 16.1543 2.51016L10.125 7.53399V9V10.466L16.1543 15.4898ZM9 12.375V9V4.5V3.375C9 2.93907 8.74688 2.5418 8.35313 2.35547C7.95938 2.16915 7.4918 2.22891 7.1543 2.51016L0.404297 8.13516C0.147656 8.34961 0 8.66602 0 9C0 9.33399 0.147656 9.6504 0.404297 9.86485L7.1543 15.4898C7.48828 15.7676 7.95586 15.8309 8.35313 15.6445C8.75039 15.4582 9 15.0609 9 14.625V12.375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToCabinet);
export default __webpack_public_path__ + "static/media/back-to-cabinet.d6d45099656d7dfe3ddfdbfe59e66085.svg";
export { ForwardRef as ReactComponent };